import { render, staticRenderFns } from "./ProjectSectionRewards.vue?vue&type=template&id=07a4c8de&"
import script from "./ProjectSectionRewards.vue?vue&type=script&lang=js&"
export * from "./ProjectSectionRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports